<!-- 销售订单数据操作 -->
<template>
  <div>
    <div>
      <div class="demo-drawer__content data_action_form">
        <el-tabs type="border-card" v-model="showTabs" class="el-tabs--border-card_new">
          <el-tab-pane :label="title" :name="title">
            <div class="table_content_box">
              <!-- 主要信息 -->
              <div>
                <el-form label-width="150px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo"
                  size="mini" :show-message="false">
                  <el-row>
                    <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in jurconfigform"
                      :key="formOneKey" v-if="showFieldInfo(formOneValue.showField, sendDataInfo.type)"
                      :prop="formOneValue.entityField"
                      :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                      <!-- 日期 -->
                      <df-date :disabled="formOneValue.isChange == 1 ? true : false"
                        v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"
                        @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)" :isShowLong="false">
                      </df-date>
                      <!-- 检索方案 -->
                      <el-input :disabled="formOneValue.isChange == 1 ? true : false" @input="inputFun"
                        v-else-if="formOneValue.entityField == 'cmName'" clearable
                        v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                        :id="formOneValue.entityField"
                        @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)">
                        <el-button :disabled="formOneValue.isChange == 1 ? true : false"
                          @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                          slot="append" icon="el-icon-search">
                        </el-button>
                      </el-input>
                      <el-input :disabled="formOneValue.isChange == 1 ? true : false"
                        v-else-if="formOneValue.fieldType == 'search'" clearable
                        v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                        :id="formOneValue.entityField"
                        @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)">
                        <el-button :disabled="formOneValue.isChange == 1 ? true : false"
                          @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                          slot="append" icon="el-icon-search">
                        </el-button>
                      </el-input>
                      <!-- formatter下拉选   :automatic-dropdown="true"-->
                      <el-select :disabled="formOneValue.isChange == 1 ? true : false" clearable size="mini"
                        v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                        @change="changeType" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                        <el-option v-for="item in formOneValue.formatterContent" :key="item.key" :label="item.key"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <el-input @input="calculatePrice(2)" :disabled="formOneValue.isChange == 1 ? true : false"
                        v-else-if="formOneValue.entityField == 'psprice'"
                        @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                        v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                      <el-input @input="calculatePrice(1)" :disabled="formOneValue.isChange == 1 ? true : false"
                        v-else-if="formOneValue.entityField == 'psmoney'"
                        @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                        v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                      <el-input @input="calculatePrice(3)" :disabled="formOneValue.isChange == 1 ? true : false"
                        v-else-if="formOneValue.entityField == 'num'"
                        @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                        v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                      <!-- string类型 -->
                      <el-input :disabled="formOneValue.isChange == 1 ? true : false" v-else
                        @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)"
                        v-model.trim="sendDataInfo[formOneValue.entityField]"
                        :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>
                  </el-row>
                </el-form>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="foot">
          <div style="margin-top: 1rem;text-align: center;">
            <el-button type="primary" @click="initActionBox('sendDataInfo')"
              v-if="dataActionBox.actionType != 2">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo',)"
              v-if="dataActionBox.actionType == 0">保存</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')"
              v-if="dataActionBox.actionType == 1">保存</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
      :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
      <SearchScheme ref="searchScheme" :id="searchId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
  name: "wobkeflowtempAction",
  props: ["actionData"],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      seWidth: "",
      showTabs: "新增出库流向",
      seTitle: "",
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      title: "新增出库流向",
      jurconfigform: [
        {
          showField: "记账日期",
          entityField: "accountTime",
          isRequired: 1,
          fieldType: "date",
          focusField: "bgmName",
          searchId: "",
          setField: "",
          formatterContent: "",
        },
        {
          showField: "单位类型",
          entityField: "type",
          isRequired: 1,
          fieldType: "formatter",
          focusField: "",
          searchId: "",
          setField: "",
          formatterContent: [{ key: '供应商', value: 1 }, { key: '客户', value: 2 }],
        },
        {
          showField: "销往单位",
          entityField: "cmName",
          isRequired: 1,
          fieldType: "search",
          focusField: "coName",
          searchId: "157783642640384",
          setField: "cmId,cmName",
          formatterContent: "",
        },
        {
          showField: "购进单位",
          entityField: "cmName",
          isRequired: 1,
          fieldType: "search",
          focusField: "coName",
          searchId: "155784192757760",
          setField: "cmId,cmName",
          formatterContent: "",
        },
        {
          showField: "货主",
          entityField: "coName",
          isRequired: 1,
          fieldType: "search",
          focusField: "bgmName",
          searchId: "4414428383875072",
          setField: "coId,coName",
          formatterContent: "",
        },
        {
          showField: "商品名称",
          entityField: "bgmName",
          isRequired: 1,
          fieldType: "search",
          focusField: "num",
          searchId: "206352637005825",
          setField: "bgsId,bgmName,bgmId",
          formatterContent: "",
        },
        {
          showField: "数量",
          entityField: "num",
          isRequired: 1,
          fieldType: "number",
          focusField: "psprice",
          searchId: "",
          setField: "",
          formatterContent: "",
        },
        {
          showField: "含税价格",
          entityField: "psprice",
          isRequired: 1,
          fieldType: "number",
          focusField: "psmoney",
          searchId: "",
          setField: "",
          formatterContent: "",
        },
        {
          showField: "含税金额",
          entityField: "psmoney",
          isRequired: 1,
          fieldType: "number",
          focusField: "keydown",
          searchId: "",
          setField: "",
          formatterContent: "",
        },

      ],
      propTitle: '销往单位',
      inputel: [],//主表单的所有input
      seIndex: 0,//索引
      sendDataInfo: {
        "accountTime": "",
        "bgmId": 0,
        "bgmName": "",
        "bgsId": 0,
        "bgsName": "",
        "cmId": 0,
        "cmName": "",
        "coId": 0,
        "coName": "",
        "num": 0,
        "psmoney": 0,
        "psprice": 0
      },
      DialogVisible: false,
      searchId: "",//检索Id
      sField: "",
      parentSearchData: {},
    };
  },
  //   watch: {
  //     "sendDataInfo.num"() {
  //       if (this.sendDataInfo.num == "") {
  //         return
  //       }
  //       this.sendDataInfo.psmoney = this.$common.getDecimalInfo(3, NP.times(parseFloat(this.sendDataInfo.psprice), parseFloat(this.sendDataInfo.num)))
  //     },
  //     "sendDataInfo.psmoney"() {
  //       if (this.sendDataInfo.psmoney == "") {
  //         return
  //       }
  //       this.sendDataInfo.psprice = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.psmoney, this.sendDataInfo.num))
  //     },
  //     "sendDataInfo.psprice"() {
  //       if (this.sendDataInfo.psprice == "") {
  //         return
  //       }
  //       this.sendDataInfo.psmoney = this.$common.getDecimalInfo(3, NP.times(parseFloat(this.sendDataInfo.psprice), parseFloat(this.sendDataInfo.num)))
  //     },
  //   },
  //监听属性 类似于data概念
  //方法集合
  methods: {
    changeType() {
      this.sendDataInfo.cmId = ''
      this.sendDataInfo.cmName = ''
    },
    inputFun() {
      console.log("************************")
      this.sendDataInfo.cmId = ''
    },
    calculatePrice(type) {
      switch (type) {
        case 1:
          this.sendDataInfo.psprice = this.$common.getDecimalInfo(3, NP.divide(this.sendDataInfo.psmoney, this.sendDataInfo.num));
          break;
        case 2:
          this.sendDataInfo.psmoney = this.$common.getDecimalInfo(3, NP.times(this.sendDataInfo.psprice, this.sendDataInfo.num));
          break;
        case 3:
          this.sendDataInfo.psmoney = this.$common.getDecimalInfo(3, NP.times(this.sendDataInfo.psprice, this.sendDataInfo.num));
          break;
      }
    },
    closeChild() { },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById("mainInfo");
      if (el) this.inputel = el.getElementsByTagName("input");
    },
    // 主表单select框切换enter切换焦点事件方法
    selectChange(e) {
      if (e == false) {
        for (let index = 0; index < this.inputel.length; index++) {
          if (this.inputel[index] == document.activeElement) {
            this.nextFocus(index);
            break;
          }
        }
      }
    },

    // 输入框切换焦点
    nextFocus(index, fField) {
      if (index >= this.inputel.length - 1) {
        return;
      }
      if (fField == "keydown") {
        return;
      }
      var aindex = index + 1;
      if (
        (this.inputel[aindex].value != "" && this.inputel[aindex].value != 0) ||
        this.inputel[aindex].disabled
      ) {
        this.nextFocus(aindex);
        return;
      }
      this.$nextTick(() => {
        this.inputel[aindex].focus();
      });
    },

    // 初始化焦点
    initFocus() {
      for (let index = 0; index < this.inputel.length; index++) {
        if (this.inputel[index].value == "") {
          this.inputel[index].focus();
          break;
        }
      }
    },
    showFieldInfo(a, b) {
      if (a != '购进单位' && a != '销往单位') {
        return true
      } else if (b == 2 && a == '销往单位') {
        return true
      } else if (b == 1 && a == '购进单位') {
        return true
      } else {
        return false
      }
    },
    // 检索Id, 索引(表格中), 标识
    //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
    openSearch(sId, index, type, sField, fField, setField) {
      if (type == "bgmName" && this.sendDataInfo.coId == "") {
        return this.$message.error("请选择货主")
      }
      this.DialogVisible = true;
      this.searchId = sId
      this.sField = sField
      if (type == "bgmName") {
        this.parentSearchData.outcoId = this.sendDataInfo.coId
      }
      this.parentSearchData[type] = this.sendDataInfo[type];

    },
    // 赋值字段
    paramValue(val) {
      if (this.searchId == '155784192757760') {
        this.sendDataInfo.cmId = val.smId;
        this.sendDataInfo.cmName = val.smName;
        this.$nextTick(() => {
          this.nextFocus(this.seIndex, this.fField);
        });
      } else {
        let arr = this.sField.split(",");
        arr.forEach((item) => {
          this.sendDataInfo[item] = val[item];
        });
        this.$nextTick(() => {
          this.nextFocus(this.seIndex, this.fField);
        });
      }
    },
    // 清除赋值字段数据
    clearValue() {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.sendDataInfo[item] = "";
      });
    },

    //检索带回数据,
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.$nextTick(() => {
          this.paramValue(val);
        });
      }
    },

    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      console.log(e);
      //   this.seTitle = e;
    },
    //确认新增
    sendDataAction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sub()
        } else {
          this.$message({
            message: "请完善主表单必填信息",
            type: "error",
          });
          flag = true;
          return false;
        }
      });

    },
    async sub() {
      if (this.sendDataInfo.num == "" || this.sendDataInfo.num == 0) {
        return this.$message.error("数量不能为0")
      }
      if (this.sendDataInfo.psprice == "" || this.sendDataInfo.psprice == 0) {
        return this.$message.error("含税价格不能为0")
      }
      if (this.sendDataInfo.psmoney == "" || this.sendDataInfo.psmoney == 0) {
        return this.$message.error("含税金额不能为0")
      }
      for (let key in this.sendDataInfo) {
        if (key == "") delete this.sendDataInfo[key];
      }
      if (this.dataActionBox.actionType == 0) {
        var responseData = await this.$http.flowtempAdd(
          this.sendDataInfo
        );
      } else {
        var responseData = await this.$http.flowtempUpdate(
          this.sendDataInfo
        );
      }

      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$emit("drawerCancel", true);
      } else {
        this.$message.error(responseData.message)
      }
    },
    drawerCancel() {
      this.$emit("drawerCancel", true);
    },
    //取消
    initActionBox(formName1, formName2) {
      this.$confirm(
        "确定取消" + this.dataActionBox.boxTitle + "吗?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$emit("drawerCancel");
          this.init();
          this.$refs[formName1][0].resetFields();
          this.$refs[formName2][0].resetFields();
        })
        .catch(() => { });
    },
    //初始化
    init() {
      for (let key in this.sendDataInfo) {
        if (key == 'num' || key == "psprice" || key == 'psmoney') {
          this.sendDataInfo[key] = 0;
        } else {
          this.sendDataInfo[key] = "";
        }
      }
    },
    initTime() {
      this.sendDataInfo.accountTime = this.$common.getEndTime()
      console.log(this.$common.getEndTime());
    },
    //上级流入
    openBox() {
      this.dataActionBox.actionType = this.actionData.cate;
      var oldData = this.actionData.oldData;
      this.init();
      if (this.dataActionBox.actionType == 0) {
        this.showTabs = "新增出库流向";
        this.title = "新增出库流向";
        this.dataActionBox.boxTitle = "新增";
        this.dataActionBox.openMode = "ltr";
        this.initTime()
      } else if (this.dataActionBox.actionType == 1) {
        this.jurconfigform.forEach(item => {
          if (item.entityField == "coName" || item.entityField == "bgmName") {
            item.isChange = 1
          }
        })
        this.cmId = oldData.cmId;
        this.ormId = oldData.ormId
          ? oldData.ormId
          : JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
        this.coId = oldData.coId;
        this.showTabs = "编辑出库流向";
        this.title = "编辑出库流向";
        this.dataActionBox.boxTitle = "修改";
        this.dataActionBox.openMode = "ltr";
        this.sendDataInfo = oldData;
        this.parentSearchData.cmId = oldData.cmId;
        for (let key in this.sendDataInfo) {
          if (this.sendDataInfo[key] == null) {
            if (key == 'num' || key == "psprice" || key == 'psmoney') {
              this.sendDataInfo[key] = 0
            } else {
              this.sendDataInfo[key] = ""
            }
          }
        }
      } else {
        this.dataActionBox.boxTitle = "查看信息";
        var dataInfo = JSON.parse(JSON.stringify(oldData));
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key];
        }
      }
      this.$nextTick(() => {
        var sheight = this.$refs["sendDataInfo"].$el.clientHeight
        if (this.dataActionBox.actionType != 2) {
          this.mxHeight =
            document.documentElement.clientHeight - sheight - 250;
        } else {
          this.mxHeight =
            document.documentElement.clientHeight - sheight - 280;
        }
        this.initFocus();
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      this.openBox();
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeDestroy() {
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput();
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

/* .table_content_box{
	height: 500px !important;
	overflow-y: auto;
} */
.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.foot {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  padding: 14px 0;
  z-index: 999;
}

.foot .el-form {
  margin-left: 20px;
}

.foot .el-form .el-form-item {
  margin-bottom: 0;
}

.el-drawer {
  outline: none;
}

.foot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #fff;
  padding: 14px 0;
  z-index: 999;
}

.foot .el-form {
  margin-left: 20px;
}

.foot .el-form .el-form-item {
  margin-bottom: 0;
}
</style>
<style>
.el-table .rowStyle {
  background: #fff7ca !important;
}
</style>